
import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import '@/assets/styles/components/order-confirm-mobile.scss'
import OrderConfirmStatus from './OrderConfirmStatus.mobile'
import { getSafe } from '@/helpers/global';
// import PIN from '../PIN/PIN';
import { openOrderCancelDialog, openOrderModifyDialog, openOTPDialog, openOrderFeesDialog } from '@/actions/app';
import { orderActions } from '@/actions/trading';
import { SERVICES_RESP } from '@/configurations';
import { PARAMS } from '@/constants/params';
import { formatFunctions } from '@/helpers/functions';
import { dataType } from '@/constants/data-type';
import { ORDER_MODE, ORDER_TYPE } from "@/constants/app";
import Tips from '@/components/Tips/Tips';
import LoadingLayer from '@/components/Spinner/LoadingLayer';
import { LOADING_TYPE } from '@/constants/app';
import {utilsFunction} from '@/helpers/functions/utilsFunction';
import {getSafeStorage } from '@/helpers/global';
import {STORAGE_KEY } from '@/constants/storage.key';

class OrderConfirmMobile extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isSend: false,
      orderTable: [],
      orderResult: {},
      isShowPrice:true,
      isResubmit:'N',
      isResubmitReasonList:[],
      loading:false,
      feeAmt:'',
      stockName:'',
      feesList:[],
      load:false,
      fee:""
    }
  }

  placeOrder = () => {
    const { language, data, currentTradingAccount } = this.props;
    const deviceID = getSafeStorage(STORAGE_KEY.DEVICE_ID);
    let stockParams = {
      [PARAMS.CLIENT_ID]: currentTradingAccount.clientID,
      [PARAMS.TRADING_ACCOUNT_ID]: currentTradingAccount.clientID,
      [PARAMS.TRADING_ACCOUNT_SEQ]: currentTradingAccount.tradingAccSeq + '',
      [PARAMS.MARKET_ID]: data.marketID,
      [PARAMS.INSTRUMENT_ID]: data.instrumentID,
      [PARAMS.BS]: data.isBuy ? 'B' : 'S',
      [PARAMS.ORDER_TYPE]: data.orderType.value,
      [PARAMS.QTY]: data.quantity + '',
      [PARAMS.LANGUAGE]: language.lang,
      [PARAMS.IS_RESUBMIT]:this.state.isResubmit,
      // [PARAMS.DEVICE_ID]: deviceID,
      // [PARAMS.AMOUNT]:data.amount
    }
    let fundsParams = {
      [PARAMS.CLIENT_ID]: currentTradingAccount.clientID,
      [PARAMS.TRADING_ACCOUNT_ID]: currentTradingAccount.clientID,
      [PARAMS.TRADING_ACCOUNT_SEQ]: currentTradingAccount.tradingAccSeq + '',
      [PARAMS.BS]: data.isAllowBuy ? 'B' : 'S',
      [PARAMS.INSTRUMENT_ID]: data.instrumentID,
      [PARAMS.MARKET_ID]: data.marketID,
      [PARAMS.ORDER_TYPE]: data.orderType.value,
      [PARAMS.DEVICE_ID]: deviceID,
          
    }

    let params = data.marketID !== "FUND"? stockParams :fundsParams
    if (data.marketID === 'FUND') {
      if (data.isAllowBuy) {
        params[PARAMS.PRICE] = data.amount 
      } else {
        params[PARAMS.QTY] = data.unit

      }
    } else {
      if(utilsFunction.isOrderNeedEnterPrice(data.orderType.value)){
        params [PARAMS.PRICE] = data.price + ''
      } else {
        params [PARAMS.PRICE] = '0'
      }
    }

    if (data.goodTillDate && data.goodTillDate.value !== '-') {
      params[PARAMS.GOOD_TILL_DATE] = data.goodTillDate.value
    }
    if(data.orderType.value === ORDER_TYPE.TRIGGER_ORDER.value) {
      params[PARAMS.STOP_TYPE] = data.stopType.value;
      params[PARAMS.STOP_PRICE] = data.stopPrice + '';
    }

    this.setState({
      isResubmit:'N',
      isResubmitReasonList:[],
      loading:true,
      isSubmit:false,
    })
    
    this.props.placeOrderAction(params, res => {
      if (res.status === SERVICES_RESP.STATUS_OK) {
        // if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
        this.setState({ orderResult: res.result })
        // }
      }
      if(res.result.errorCode === SERVICES_RESP.SUCCESS_CODE){
        if(res.result.isSuccess === 'N'){
          const reasonsList = res.result.reasonsList;
          let reasons = [];
          let needResubmit = false;
          for (let i = 0; i < reasonsList.length; i++) {
            const item = reasonsList[i];
            if(item.action === 'W'){
              reasons.push(item.reason);
              needResubmit = true;
            }else if(item.action === 'I'){
              needResubmit = true;
            }else{
              reasons.splice(0,reasons.length);
              needResubmit = false;
              break;
            }
            this.setState({ loading:false })
          }
          if(needResubmit){
            this.setState({
              isResubmit:'Y'
            },() => {
              if(reasons.length > 0){
                this.setState({
                  isResubmitReasonList:reasons
                }) 
              }
            })
          }
        }
      }
      if(this.state.isResubmit !== 'Y'){
        let el;
        if(this.props.isPortfolio){
          el = document.getElementsByClassName('title')[2];
        }else{
          el = document.getElementsByClassName('title')[0];
        }
        if (el) {
          const { language } = this.props;
          el.innerHTML = language.order_result;
        }
          this.setState({ isSend: true ,loading:false})
      }
    })
  }

  modifyOrder = () => {
    const { language, data, currentTradingAccount, isMobile } = this.props;
    const orderType = data.orderType.value ? data.orderType.value : data.orderType
    let params = {
      [PARAMS.CLIENT_ID]: currentTradingAccount.clientID,
      [PARAMS.TRADING_ACCOUNT_ID]: currentTradingAccount.clientID,
      [PARAMS.TRADING_ACCOUNT_SEQ]: currentTradingAccount.tradingAccSeq + '',
      [PARAMS.LANGUAGE]: language.lang,
      [PARAMS.ORDER_GROUP_ID]: data.orderGroupID,
      [PARAMS.ORDER_ID]: data.orderID,
      [PARAMS.NEW_QTY]: data.newQTY + '',
      [PARAMS.IS_RESUBMIT]:this.state.isResubmit
    }
    if(utilsFunction.isOrderNeedEnterPrice(orderType)){
      params[PARAMS.NEW_PRICE] =  data.newPrice + '';
    }
    this.setState({
      isResubmit:'N',
      isResubmitReasonList:[],
      loading:true,
      isSubmit:false,
    })
    this.props.getOrderFeesAction(params, res => {
      if (res.status === 'ST200' && res.result && Array.isArray(res.result.feesList) && res.result.feesList.length) {
        const fessData = res.result.feesList.find(v => v.feeID === (isBuy ? 'FUND.SUB' : 'FUND.REDEM'))
        if (fessData) {
          const { chargeRate } = fessData
          if (!isNaN(chargeRate)) {
            this.setState({ [isBuy ? 'fundAmount' : 'fundUnit']: formatFunctions.dataFormat(chargeRate * 100, dataType.CASH) })
          } else {
            this.setState({ [isBuy ? 'fundAmount' : 'fundUnit']: '-' })
          }
        }
      }
    })
    this.props.modifyOrder(params, res => {
      if (res.status === SERVICES_RESP.STATUS_OK) {
        // if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
          if(res.result.isSuccess === 'N'){
            const reasonsList = res.result.reasonsList;
            let reasons = [];
            let needResubmit = false;
            for (let i = 0; i < reasonsList.length; i++) {
              const item = reasonsList[i];
              if(item.action === 'W'){
                reasons.push(item.reason);
                needResubmit = true;
              }else if(item.action === 'I'){
                needResubmit = true;
              }else{
                reasons.splice(0,reasons.length);
                needResubmit = false;
                break;
              }
              this.setState({ loading:false })
            }
            if(needResubmit){
              this.setState({
                isResubmit:'Y'
              },() => {
                if(reasons.length > 0){
                  this.setState({
                    isResubmitReasonList:reasons
                  }) 
                }
              })
            }
          }
          if(this.state.isResubmit !== 'Y'){
            const orderResult = {
              ...this.props.data,
              ...res.result,
              isSuccess: res.result.isSuccess,
              orderID: this.props.data.orderID,
              inputTime: this.props.data.inputTime,
              newPrice: params[PARAMS.NEW_PRICE],
              newQty: params[PARAMS.NEW_QTY],
              feesList: this.state.feesList,
              feeAmt: this.state.feeAmt ? this.state.feeAmt : res.result.feeAmt
            }
            this.setState({
              orderResult,
              isSend: true,
            },() => {
              const { language } = this.props;
              let el;
              if(this.props.isPortfolio){
                el = document.getElementsByClassName('title')[2];
              }else{
                el = document.getElementsByClassName('title')[0];
              }
              if(res.result.isSuccess === 'Y'){
                this.props.closeAllBox(true)
              }
              if (el) {
                for (let i = 0; i < el.length; i++) {
                  if(el[i].innerText===language.order_confirm_title){
                    el[i].innerText = language.order_result
                  }
                }
              }
              // this.props.onHasResult()
            })
          }
        // }
      }
      this.setState({
        loading: false
      })
    })
  }

  closeDialog = (isCloseDialog) => {
    this.props.closeLayout()
  }

  handleConfirm = () => {
    // openOTPDialog(this.handleGetOTPCode)
    if(this.props.data.isModifyOrder === 'Y'){
      this.modifyOrder()
    }else{
      this.placeOrder()
    }
  }

  handleGetOTPCode = (otpCode) => {
    if (otpCode) {
      this.placeOrder()
    }
  }

  mappingOrderData = data => {
    const { language, currentTradingAccount} = this.props
    const { feeAmt } = this.state;
    if(data.isModifyOrder && data.isModifyOrder === 'Y'){
      let orderTable =[
        {
          label: 'place_order_dialog_cash_account',
          value: currentTradingAccount.tradingAccountID
        },
        {
          label: 'common_order_type',
          value: language[`order_type_${data.orderType.toLowerCase()}`]
        },
        {
          label: 'order_original_price',
          value: `${data.currencyID} ${formatFunctions.dataFormat(data.price, dataType.CURRENCY)}`
        },
        {
          label: 'order_new_price',
          value: `${data.currencyID} ${formatFunctions.dataFormat(data.newPrice, dataType.CURRENCY)}`
        },
        {
          label: 'common_stop_type',
          value: data.stopType ? language[data.stopType.label] : '-'
        },
        {
          label: 'common_stop_price',
          value: data.stopPrice ? `${data.currencyID} ${formatFunctions.dataFormat(data.stopPrice, dataType.CURRENCY)}` : '-'
        },
        {
          label: 'order_original_quantity',
          value: `${formatFunctions.dataFormat(data.qty, dataType.NUMBER)} ${language.common_share.format(
            language.lang === 'en_US' && data.qty > 1 ? 's' : ''
          )}`
        },
        {
          label: 'order_new_quantity',
          value: `${formatFunctions.dataFormat(data.newQTY, dataType.NUMBER)} ${language.common_share.format(
            language.lang === 'en_US' && data.newQTY > 1 ? 's' : ''
          )}`
        },
        {
          label: 'common_good_till_date',
          value: data.goodTillDate ? data.goodTillDate.value : '-'
        }
      ]
      if(!utilsFunction.isOrderNeedEnterPrice(data.orderType)){
        for (let i = 0; i < orderTable.length; i++) {
          let item = orderTable[i];
          if(item.label === 'order_original_price' || item.label === 'order_new_price'){
            item.value = '-'
          }
        }
      }
      this.setState({ orderTable })
    }else if(data.marketID === "FUND"){
      let orderTable = [
        {
          label: 'place_order_dialog_cash_account',
          value: data.cashAccount.label ? data.cashAccount.label : data.cashAccount  ? data.cashAccount : '-'
        },
        (data.fundActionType=== "Subscription" ?
        { 
          label: 'common_amount',
          value: `${data.currencyID} ${formatFunctions.dataFormat(data.amount, dataType.STOP_PRICE)}`
        }:
        {
          label: 'fund_Unit',
          value: `${formatFunctions.dataFormat(data.unit, dataType.FUNDS_QUANTITY)}`
        }),
        {
          label: 'common_good_till_date',
          value: data.goodTillDate ? data.goodTillDate.value : '-'
        }
      ]
      this.setState({ orderTable })
    }else{
      let orderTable = [
        {
          label: 'place_order_dialog_cash_account',
          value: data.cashAccount.label ? data.cashAccount.label : data.cashAccount  ? data.cashAccount : '-'
        },
        {
          label: 'common_order_type',
          value: language[`order_type_${data?.orderType?.value?.toLowerCase()}`] || '-'
        },
        {
          label: 'common_price',
          value: `${data.currencyID} ${formatFunctions.dataFormat(data.price, dataType.CURRENCY)}`
        },
        {
          label: 'common_stop_type',
          value: data.stopType ? language[data.stopType.label] : '-'
        },
        {
          label: 'common_stop_price',
          value: data.stopPrice ? `${data.currencyID} ${formatFunctions.dataFormat(data.stopPrice, dataType.CURRENCY)}` : '-'
        },
        {
          label: 'common_quantity',
          value: `${formatFunctions.dataFormat(data.quantity, dataType.NUMBER)} ${language.common_share.format(
            language.lang === 'en_US' && data.quantity > 1 ? 's' : ''
          )}`
        },
        {
          label: 'common_good_till_date',
          value: data.goodTillDate ? data.goodTillDate.value : '-'
        }
      ]
      if(!utilsFunction.isOrderNeedEnterPrice(data.orderType.value)){
        for (let i = 0; i < orderTable.length; i++) {
          let item = orderTable[i];
          if(item.label === 'common_price'){
            item.value = '-';
          }
        }
      }
      this.setState({ orderTable })
    }
  }

  handleShowPrice = data => {
    if(data.isModifyOrder && data.isModifyOrder === 'Y'){
      const isShowPrice = utilsFunction.isOrderNeedEnterPrice(data.orderType);
      this.setState({
        isShowPrice:isShowPrice
      })
    }else{
      const isShowPrice = utilsFunction.isOrderNeedEnterPrice(data.orderType.value);
      this.setState({
        isShowPrice:isShowPrice
      })
    }
  }

  getCommissionAndFees = () => {
    const {language, currentTradingAccount, data} = this.props;
    const {clientID, tradingAccSeq} = currentTradingAccount;
    let params = {};
    if(data.isModifyOrder && data.isModifyOrder === 'Y'){
      const {marketID, instrumentID, bs, newPrice, newQTY} = data;
      params = {
        [PARAMS.CLIENT_ID]: clientID,
        [PARAMS.TRADING_ACCOUNT_ID]: clientID,
        [PARAMS.TRADING_ACC_SEQ]: String(tradingAccSeq),
        [PARAMS.LANGUAGE]: language.lang,
        [PARAMS.MARKET_ID]:marketID,
        [PARAMS.INSTRUMENT_ID]:instrumentID,
        [PARAMS.BS]:bs,
        [PARAMS.PRICE]: String(newPrice),
        [PARAMS.QTY]:String(newQTY)
      }
    }else{
      const {marketID, instrumentID, isBuy, price, quantity,isAllowBuy,unit,amount} = data;
      params = {
        [PARAMS.CLIENT_ID]: clientID,
        [PARAMS.TRADING_ACCOUNT_ID]: clientID,
        [PARAMS.TRADING_ACC_SEQ]: String(tradingAccSeq),
        [PARAMS.LANGUAGE]: language.lang,
        [PARAMS.MARKET_ID]:marketID,
        [PARAMS.INSTRUMENT_ID]:instrumentID,
        [PARAMS.BS]:isBuy? 'B':'S',
        [PARAMS.PRICE]: price,
        [PARAMS.QTY]:quantity
      }
      if(marketID === "FUND"){
        params[PARAMS.BS] = isAllowBuy?'B':'S'
        if(isAllowBuy){
          params[PARAMS.PRICE] = amount
        }else{
          params[PARAMS.QTY]=unit
        }
      }
    }
    this.setState({
      loading:true
    })
    this.props.getOrderFeesAction(params, res => {
      if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
        if(data.marketID === "FUND"){
          this.setState({
            fee:formatFunctions.dataFormat(res.result.feesList[0].chargeRate * 100, dataType.CASH),
            loading:false
          })
        }else{
          this.setState({
            feeAmt:res.result.feeAmt,
            feesList:res.result.feesList,
            loading:false
          })
        }
       
      }else{
        this.setState({
          feeAmt:"-",
          feesList:[],
          loading:false
        })
      }
    })
  }

  getFundsTotal(){
    const {data} = this.props;
    const {isShowPrice,fee} = this.state;
    let fundTotalAmount = ''
    if(!isShowPrice){
      return '-';
    }
    if(fee && fee != "-") {
      if(data.fundActionType === "Subscription"){
        fundTotalAmount = formatFunctions.dataFormat((Number(data.amount) + Number(fee)), dataType.STOP_PRICE);
      }else {
        // fundTotalAmount = formatFunctions.dataFormat((Number(data.unit ) - Number(data.fee)), dataType.STOP_PRICE)
        fundTotalAmount = '-'
      }
    }
    return data.currencyID + ' ' + String(fundTotalAmount)
  }

  isResubmitReasonTips = () => {
    const {isResubmitReasonList} = this.state;
    const isResubmitReasonTips = [];
    isResubmitReasonList.map((isResubmitReason, index) => {
      isResubmitReasonTips.push(<Tips key={index} isSuccess={false} isWarning={true}>{isResubmitReason}</Tips>)
    })
    return isResubmitReasonTips;
  }

  componentDidMount() {
    this.mappingOrderData(this.props.data);
    this.handleShowPrice(this.props.data);
    if(this.props.data.isModifyOrder ==='Y'){
      if(utilsFunction.isOrderNeedEnterPrice(this.props.data.orderType)){
        this.getCommissionAndFees();
      }
    }else{
      if(utilsFunction.isOrderNeedEnterPrice(this.props.data.orderType.value)){
        this.getCommissionAndFees();
      }
    }
    if(this.props.language.title === 'zh_TW' || this.props.language.title === 'zh_CN'){
      if(this.props.data.instrumentChineseName){
        this.setState({
          stockName:this.props.data.instrumentChineseName
        })
      }else{
        this.setState({
          stockName:this.props.data.instrumentName
        })
      }
    }else{
      this.setState({
        stockName:this.props.data.instrumentName
      })
    }
  }

  componentDidUpdate(prevState){
    if(prevState.isShowPrice !== this.state.isShowPrice){
      let newOrderTable = JSON.parse(JSON.stringify(this.state.orderTable));
      for(let newOrder of newOrderTable){
        if(newOrder.label === 'common_price'){
          newOrder.value = '-'
          break
        }
      }
      // setTimeout(() => {
      //   this.setState({
      //     orderTable:newOrderTable
      //   })
      // }, 200)
    }
  }

  getTotalAmount(){
    const {data} = this.props;
    const {isShowPrice,feeAmt} = this.state;
    let totalAmount = ''
    if(!isShowPrice){
      return '-';
    }
    if(data.isModifyOrder === 'Y'){
      if(feeAmt && feeAmt != '-'){
        if(data.bs ==='B'){
          totalAmount = formatFunctions.dataFormat((Number(data.newPrice * data.newQTY) + Number(feeAmt)), dataType.CASH);
        }else{
          totalAmount = formatFunctions.dataFormat((Number(data.newPrice * data.newQTY) - Number(feeAmt)), dataType.CASH);
        }
      }else{
        totalAmount = formatFunctions.dataFormat(data.newPrice * data.newQTY, dataType.CASH);
      }
    }else{
      if(feeAmt && feeAmt != '-'){
        if(data.isBuy){
          totalAmount = formatFunctions.dataFormat((Number(data.price * data.quantity) + Number(feeAmt)), dataType.CASH);
        }else{
          totalAmount = formatFunctions.dataFormat((Number(data.price * data.quantity) - Number(feeAmt)), dataType.CASH);
        }
      }else{
        totalAmount = formatFunctions.dataFormat(data.price * data.quantity, dataType.CASH);
      }
    }
    return data.currencyID + ' ' + String(totalAmount);
  }

  render() {
    const { language, data, isMobile } = this.props
    const { isSend, orderTable, orderResult,isShowPrice,isResubmitReasonList,loading, feeAmt, feesList,stockName , fee} = this.state
    return (
        <React.Fragment>
          {!isSend &&
          <div className="order-confirm-box-mobile" style={{ width: isMobile && '100%' }}>
            <LoadingLayer load={loading} type={LOADING_TYPE.BIG_IMG}/>
            {isResubmitReasonList.length > 0 && this.isResubmitReasonTips()}
            {/* <b> */}
              <div className="order-confirm-title">
                {`${data.marketID}.${data.instrumentID ? data.instrumentID : data.stockCode} ${stockName ? stockName : '-'}`}
              </div>
              {data.marketID === "FUND" ?
                <div className={classnames("order-confirm-action-price", (data.isAllowBuy  ? 'buy-color' : 'sell-color'))}>
                 <div>{getSafe(() => language[`${data.isAllowBuy? 'common_funds_subscription' : 'common_funds_redemption'}`])}</div>
                 {/* <div>{this.getFundsTotal()}</div>   */}
               </div>:
                <div className={classnames("order-confirm-action-price", (data.isBuy ? 'buy-color' : 'sell-color'))}>
                <div>{getSafe(() => language[`${data.isBuy? 'common_buy' : 'common_sell'}`])}</div>
                <div>{this.getTotalAmount()}</div>  
              </div>
              // <div className={classnames("order-confirm-action-price", data.isBuy ? 'buy-color' : 'sell-color')}>
              //   <div>{getSafe(() => language[`${data.isBuy ? 'common_buy' : 'common_sell'}`])}</div>
              //   <div>{this.getTotalAmount()}</div>
              // </div>
            }
            {/* </b> */}
            <section>
              {orderTable.map(item =>
                  <div key={item.label}>
                    <span className='span-left'>{getSafe(() => language[item.label])}</span>
                    <span className='span-right'><span>{item.value}</span>
                  </span>
                  </div>
              )}
              {data.marketID !== "FUND" ?
              <div>
                <span className='span-left'>
                  <div style={feesList.length>0 ? {cursor:'pointer',display:'inline-block',textDecoration:'underline'} : {display:'inline-block'}}
                    onClick={() => {if (feesList.length > 0) openOrderFeesDialog(feesList,data.currencyID,feeAmt)}}>
                    {getSafe(() => language.common_commission_fees)}
                  </div>
                </span>
                <span className='span-right'>
                  <b>{(feeAmt && feeAmt != '-') ? data.currencyID + ' ' + formatFunctions.dataFormat(feeAmt,dataType.CASH) : '-'}</b>
                </span>
              </div>: 
              <div>
                <span className='span-left'>
                  <div>
                    {getSafe(() => language[data.fundActionType === "Subscription" ? 'common_funds_subscription_fee' : 'common_funds_redemption_fee'])}
                  </div>
                </span>
                <span className='span-right'>
                  <b>{fee}</b>
                </span>
              </div>}
              {/* <div>
                <span className='span-left'>
                  <div style={feesList.length>0 ? {cursor:'pointer',display:'inline-block',textDecoration:'underline'} : {display:'inline-block'}}
                    onClick={() => {if (feesList.length > 0) openOrderFeesDialog(feesList,data.currencyID,feeAmt)}}>
                    {getSafe(() => language.common_commission_fees)}
                  </div>
                </span>
                <span className='span-right'>
                  <span>{(feeAmt && feeAmt != '-') ? data.currencyID + ' ' + formatFunctions.dataFormat(feeAmt,dataType.CASH) : '-'}</span>
                </span>
              </div> */}
            </section>
            {/* <div>
              <PIN />
            </div> */}
            <footer>
              <div style={{display:loading ? 'none' :'flex'}}>
                <button className="cancel-btn"
                        onClick={() => this.closeDialog(false)}>{getSafe(() => language.common_cancel)}</button>
                <button className="confirm-btn"
                        onClick={this.handleConfirm}>{getSafe(() => language.common_confirm)}</button>
              </div>
            </footer>
          </div>
          }
          {isSend &&
          <OrderConfirmStatus
              orderData={data}
              orderResult={orderResult}
              onClose={this.closeDialog}
              mode={data.isModifyOrder === 'Y' ? ORDER_MODE.MODIFY:ORDER_MODE.CREATE}
          />
          }
        </React.Fragment>
    )
  }
}

export default connect(
    state => ({
      language: state.app.language,
      isMobile: state.app.isMobile,
      currentTradingAccount: state.trade.currentTradingAccount
    }),
    dispatch => ({
      placeOrderAction: (p, res) => dispatch(orderActions.placeOrderAction(p, res)),
      getOrderFeesAction: (p, res) => dispatch(orderActions.getOrderFeesAction(p, res)),
      modifyOrder: (p, res) => dispatch(orderActions.modifyOrderAction(p, res))
    })
)(OrderConfirmMobile)